import { ReactNode, useRef } from "react";

import classNames from "classnames";

import styles from "./styles.module.css";

/** The set of supported action bar layout types. */
export type LayoutType = "auto" | "auto-unpadded" | "fixed" | "fixed-unpadded" | "fullscreen";

export interface ActionBarItem {
  readonly id: string;
  readonly content: ReactNode;
}

export interface ActionBarsProps {
  readonly actions: ReadonlyArray<ActionBarItem>;
  readonly layoutType?: LayoutType;
  readonly breadcrumbs?: ReactNode;
}

/**
 * Shell-only component. Do not use this outside the shell.
 */
export const ActionBars = (props: ActionBarsProps): ReactNode => {
  const { actions, layoutType = "auto", breadcrumbs } = props;
  const actionBarContainerRef = useRef<HTMLDivElement | null>(null);

  if (actions.length === 0 || layoutType.startsWith("fullscreen")) {
    return null;
  }

  return (
    <div data-testid="actionbar" className={classNames("action-bars", styles.root)}>
      <div ref={actionBarContainerRef} className="bar-container">
        {actions.map((action, index) => (
          <div key={action.id} className={`${styles.bar} bar`}>
            {index === 0 && breadcrumbs}
            <div className={`${styles.content} content`}>{action.content}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
